import payVisa from '../../shared/assets/images/pay-visa.svg';
import payMastercard from '../../shared/assets/images/pay-mastercard.svg';
import payApplePay from '../../shared/assets/images/pay-apple-pay.svg';

/** Accepted payment marks, in the order of Figma node 6653:15785. Kaspi and
 *  Google Pay exist in the design's component set but are switched off there,
 *  so they are not shipped. */
const paymentMarks = [
  { src: payVisa, alt: 'Visa' },
  { src: payMastercard, alt: 'Mastercard' },
  { src: payApplePay, alt: 'Apple Pay' },
];

export function PaymentSystems({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {paymentMarks.map((mark) => (
        <img key={mark.alt} src={mark.src} alt={mark.alt} className="h-6 w-[35px]" loading="lazy" />
      ))}
      {/* The certification badge keeps its own green→blue gradient from the
          design (node 6653:15791) — it is a certification mark, so it sits
          outside the landing's violet palette on purpose. */}
      <span className="rounded-md border border-[#00dc58] bg-[linear-gradient(90deg,#00dc58_0%,#00acde_100%)] bg-clip-text px-3 py-[5px] text-xs font-semibold text-transparent">
        PCI DSS Certified
      </span>
    </div>
  );
}
